var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import NavigationMenu from "../NavigationMenu";
const Footer = (_a) => {
    var { children, className, displayCopyright = true, logo, menu, type } = _a, props = __rest(_a, ["children", "className", "displayCopyright", "logo", "menu", "type"]);
    return (React.createElement("footer", Object.assign({ role: "contentinfo", className: classNames("gerudo-footer", className, {
            quebec: type === "gouv-quebec",
        }) }, props),
        menu && (React.createElement("div", { className: "menu-center" },
            React.createElement(NavigationMenu, { menu: menu }))),
        children,
        logo && React.createElement("div", { className: "footer-logo" }, logo),
        displayCopyright && React.createElement("div", { className: "copyright" },
            "\u00A9 Gouvernement du Qu\u00E9bec, ",
            new Date().getFullYear())));
};
export default Footer;
export { Footer };
//# sourceMappingURL=index.js.map